import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export const EULAView = ({ page, setPage }) => {

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="80vh"
    >
      <Card sx={{ width: "80%", maxWidth: 600, maxHeight: "80vh", autoScroll: true, overflowY: "auto" }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            User Agreement (EULA)
          </Typography>
          <div>
            <Typography variant="body1" paragraph>
              1. Acceptance of Terms
              <br />
              By accessing or using the “Make Gay Friends” app, you agree to be
              bound by these terms and conditions. If you do not agree to these
              terms, please do not use the app.
            </Typography>
            <div>
              2. User Conduct
              <br />
              You agree to use the app in a manner that is lawful and respectful
              to other users. The following behaviors are strictly prohibited:
              <ul>
                <li>
                  Posting or sharing any content that is objectionable,
                  offensive, or abusive.
                </li>
                <li>Engaging in harassment, threats, or any form of bullying.</li>
                <li>
                  Discriminating against or targeting individuals based on their
                  sexual orientation, gender identity, race, ethnicity,
                  religion, or any other characteristic.
                </li>
              </ul>
            </div>
            <div variant="body1" paragraph>
              3. Content Guidelines
              <br />
              All content shared on the app must adhere to the following
              guidelines:
              <ul>
                <li>No explicit or pornographic material.</li>
                <li>No hate speech or incitement to violence.</li>
                <li>No spam or unsolicited advertisements.</li>
              </ul>
            </div>
            <Typography variant="body1" paragraph>
              4. Account Termination
              <br />
              We reserve the right to terminate or suspend your account without
              notice if you violate these terms. This includes, but is not
              limited to, engaging in any of the prohibited behaviors listed
              above.
            </Typography>
            <Typography variant="body1" paragraph>
              5. No Tolerance Policy
              <br />
              We have a zero-tolerance policy for objectionable content and
              abusive behavior. Any violations will result in immediate action,
              including account suspension or termination.
            </Typography>
            <Typography variant="body1" paragraph>
              6. Changes to Terms
              <br />
              We may update these terms from time to time. Continued use of the
              app after any changes indicates your acceptance of the new terms.
            </Typography>
            <Typography variant="body1" paragraph>
              7. Contact Information
              <br />
              If you have any questions or concerns about these terms, please
              contact us at support@makegayfriends.com.
            </Typography>
          </div>
          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              onClick={() => setPage(page + 1)}
            >
              I agree
            </Button>
            <Button variant="text" color="error">
              Cancel
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};